export const copilotChatTextAreaId = 'copilot-chat-textarea'
export const copilotChatSearchInputId = 'copilot-chat-topic-search'
export const reviewUserMessage = 'Review'
export const copilotChatHeaderButtonID = 'copilot-chat-header-button'
export const copilotDiffHeaderButtonID = 'copilot-diff-header-button'
export const copilotChatPanelID = 'copilot-chat-panel'
export const copilotChatPanelInnerID = 'copilot-chat-panel'
export const copilotDockedPanelID = 'copilot-chat-docked-content'
export const copilotDockedPanelHeaderID = 'copilot-chat-docked-header'
export const copilotDockedPanelReadyEvent = 'copilot-docked-panel:ready'
export const copilotDockedPanelClosedEvent = 'copilot-docked-panel:closed'
